// extracted by mini-css-extract-plugin
module.exports = {"container":"loan-fgts_container__u5iLS"};